import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild, OnDestroy,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormField } from '../../../../dto/util/form-field';
import { DatosAdicionalesService } from '../services/datos-adicionales.service';
import { ListaDTO } from '../dtos/lista-DTO';
import { DataUsuario } from '../../../configuracion-cuenta/dto/data-usuarioDTO';
import {
  DatosAdicionalesPersonaDTO,
  GetDatoAdicionalesPersonaDTO,
} from '../dtos/datos-adicionales-persona-DTO';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { Constants } from '../../../../constants/constants';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {combineLatest, Subscription} from 'rxjs';
import { Router } from '@angular/router';
import { UserDataDto } from '../../../../dto/auth/user-data.dto';
import { ModalDatosAdicionalesAbogadoComponent } from '../modal-datos-adicionales-abogado/modal-datos-adicionales-abogado.component';

@Component({
  selector: 'app-modal-datos-adicionales',
  templateUrl: './modal-datos-adicionales.component.html',
  styleUrl: './modal-datos-adicionales.component.scss',
})
export class ModalDatosAdicionalesComponent implements OnInit, OnChanges, OnDestroy {
 @ViewChild(ModalDatosAdicionalesAbogadoComponent)
  ModalDatosAdicionalesAbogadoComponent!: ModalDatosAdicionalesAbogadoComponent;
  @ViewChild('modalDatosAdicionales') modalDatosAdicionales!: ElementRef;
  @Input() camposPersona: string[] = [
    'municipality',
    'idTipoArea',
    'direccion',
    'codigoPostal',
    'fechaNacimiento',
    'idGenero',
    'idEstratoSocioeconomico',
    'idGrupoEtnico',
    'idNivelEducativo',
    'idOcupacion',
    'idTiposDiscapacidad',
    'idNivelAccesoTecnologia',
  ];
  @Output() submitAction = new EventEmitter<FormGroup>();
  private langChangeSub!: Subscription;
  dataUsuario!: DataUsuario;

  allFields: FormField[] = [];

  datosPersona: DatosAdicionalesPersonaDTO = {};

  // Multilenguaje
  modalText: any = {};
  comunText: any = {};
  // ruta
  ruta: string = '';
  edadMinima: number = Constants.ANIOS_ADULTO;
  openModalAbogado: boolean = false;
  primerInicioSesion: boolean = false;

  @Input() openConfigCuenta: boolean = false;
  constructor(
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly router: Router
  ) {
    this.ruta = this.router.url;
  }

  ngOnInit() {
    this.obtenerDataUsuario();
    combineLatest({
      modal: this.translate.stream('datos-adicionales'),
      comun: this.translate.stream('comun-label'),
    }).subscribe(({ modal, comun }) => {
      // Asignar traducciones a variables
      this.modalText = modal;
      this.comunText = comun;
      this.cargarFormulario();
    });
    this.getTipoArea();
    this.getGenero();
    this.getEstratoSocioeconomico();
    this.getGrupoEtnico();
    this.getNivelEducativo();
    this.getOcupacion();
    this.getDiscapacidad();
    this.getNivelTecnologia();
    this.getDatosAdicionalesPersona(this.dataUsuario.idPersona);

    this.langChangeSub = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.getTipoArea();
        this.getGenero();
        this.getGrupoEtnico();
        this.getNivelEducativo();
        this.getOcupacion();
        this.getDiscapacidad();
        this.getNivelTecnologia();
      }
    );
  }

  obtenerDataUsuario() {
    const data = sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE);
    this.dataUsuario = data != null ? JSON.parse(data) : null;
    const dataAux = JSON.parse(data!);
    this.primerInicioSesion = dataAux.primerInicioSesion;
  }

  cargarFormulario() {
    this.allFields = [
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: this.primerInicioSesion,
        width: '6',
        visible: this.primerInicioSesion,
        isMaxDate: true,
        errorMessages: {
          required: this.comunText['fecha-nacimiento-required'],
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'email',
        label: this.comunText['email-alertas'],
        type: 'email',
        required: this.primerInicioSesion,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: this.primerInicioSesion,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'emailConfirm',
        label: this.comunText['email-confirm'],
        type: 'email',
        required: this.primerInicioSesion,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: this.primerInicioSesion,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
          notEqual: this.comunText['email-no-coincide']
        },
      },
      {
        name: 'idTipoArea',
        label: this.modalText['tipo-area'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.modalText['tipo-area-required'] },
        value: this.datosPersona.idTipoArea,
      },
      {
        name: 'codigoPostal',
        label: this.modalText['codigo-postal'],
        type: 'number',
        required: true,
        placeholder: this.modalText['codigo-postal-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(6),
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.modalText['codigo-postal-required'],
          maxlength: this.modalText['codigo-postal-maxlength'],
          pattern: this.modalText['codigo-postal-pattern'],
        },
        value: this.datosPersona.codigoPostal,
      },
      {
        name: 'idGenero',
        label: this.modalText['genero'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.modalText['genero-required'] },
      },
      {
        name: 'idEstratoSocioeconomico',
        label: this.modalText['estrato-socioeconomico'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.modalText['estrato-socioeconomico-required'],
        },
        value: this.datosPersona.idEstratoSocioeconomico,
      },
      {
        name: 'idGrupoEtnico',
        label: this.modalText['etnia'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.modalText['etnia-required'] },
        value: this.datosPersona.idGrupoEtnico,
      },
      {
        name: 'idNivelEducativo',
        label: this.modalText['nivel-educativo'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.modalText['nivel-educativo-required'] },
        value: this.datosPersona.idNivelEducativo,
      },
      {
        name: 'idOcupacion',
        label: this.modalText['ocupacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.modalText['ocupacion-required'] },
        value: this.datosPersona.idOcupacion,
      },
      {
        name: 'idTiposDiscapacidad',
        label: this.modalText['discapacidad'],
        type: 'select',
        multiple: true,
        required: true,
        options: [],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.modalText['discapacidad-required'],
        },
        value: this.datosPersona.idTiposDiscapacidad,
      },
      {
        name: 'idNivelAccesoTecnologia',
        label: this.modalText['tecnologia'],
        type: 'select',
        multiple: true,
        required: true,
        options: [],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.modalText['tecnologia-required'],
        },
        value: this.datosPersona.idNivelAccesoTecnologia,
      },
    ];
  }

  onSubmitFormulario(form: FormGroup) {
    if (form != undefined) {
      if (
        form.get('idNivelAccesoTecnologia')?.value &&
        form.get('idNivelAccesoTecnologia')?.value.includes(583)
      ) {
        form.get('idNivelAccesoTecnologia')?.setValue([583]);
      }
      if (
        form.get('idTiposDiscapacidad')?.value &&
        form.get('idTiposDiscapacidad')?.value.includes(982)
      ) {
        form.get('idTiposDiscapacidad')?.setValue([982]);
      }
      if (form.get('email')?.value && form.get('emailConfirm')?.value) {
        const emailEqual = form.get('email')?.value == form.get('emailConfirm')?.value;
        if (!emailEqual) {
          form.get('emailConfirm')?.setErrors({ notEqual: true });
        } else {
          form.get('emailConfirm')?.setErrors(null);
        }
      }
      this.submitAction.emit(form);
    }
  }

  /**
   * listas
   */
  getTipoArea() {
    this.datosProvisionalesService
      .getTipoArea()
      .subscribe((tipoAreas: ListaDTO[]) => {
        const tiposAreas = tipoAreas.map(area => ({
          Id: area.Id,
          Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? area.Valor : area.Valor_en,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idTipoArea') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposAreas;
          }
          return field;
        });
      });
  }

  getGenero() {
    this.datosProvisionalesService
      .getGenero()
      .subscribe((generos: ListaDTO[]) => {
        const tiposGeneros = generos.map(genero => ({
          Id: genero.Id,
          Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? genero.Valor : genero.Valor_en,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idGenero') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposGeneros;
          }
          return field;
        });
      });
  }

  getEstratoSocioeconomico() {
    this.datosProvisionalesService
      .getEstratoSocioeconomico()
      .subscribe((estrato: ListaDTO[]) => {
        const tiposEstatoSocioeconomico = estrato.map(estrato => ({
          Id: estrato.Id,
          Nombre: estrato.Valor,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idEstratoSocioeconomico') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposEstatoSocioeconomico;
          }
          return field;
        });
      });
  }

  getGrupoEtnico() {
    this.datosProvisionalesService
      .getGrupoEtnico()
      .subscribe((etnias: ListaDTO[]) => {
        const tiposGrupoEtnico = etnias.map(etnia => ({
          Id: etnia.Id,
          Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? etnia.Valor : etnia.Valor_en,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idGrupoEtnico') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposGrupoEtnico;
          }
          return field;
        });
      });
  }

  getNivelEducativo() {
    this.datosProvisionalesService
      .getNivelEducativo()
      .subscribe((nivelesEducativos: ListaDTO[]) => {
        const tiposNivelEducativo = nivelesEducativos.map(nivel => ({
          Id: nivel.Id,
          Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? nivel.Valor : nivel.Valor_en,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idNivelEducativo') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposNivelEducativo;
          }
          return field;
        });
      });
  }

  getOcupacion() {
    this.datosProvisionalesService
      .getOcupacion()
      .subscribe((ocupaciones: ListaDTO[]) => {
        const tiposOcupacion = ocupaciones.map(ocupacion => ({
          Id: ocupacion.Id,
          Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? ocupacion.Valor : ocupacion.Valor_en,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idOcupacion') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposOcupacion;
          }
          return field;
        });
      });
  }

  getDiscapacidad() {
    this.datosProvisionalesService
      .getDiscapacidad()
      .subscribe((discapacidades: ListaDTO[]) => {
        const tiposDiscapacidad = discapacidades.map(discapacidad => ({
          Id: discapacidad.Id,
          Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? discapacidad.Valor : discapacidad.Valor_en,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idTiposDiscapacidad') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposDiscapacidad;
          }
          return field;
        });
      });
  }

  getNivelTecnologia() {
    this.datosProvisionalesService
      .getNivelTecnologia()
      .subscribe((tecnologias: ListaDTO[]) => {
        const tiposNivelTecnologia = tecnologias.map(tecnologia => ({
          Id: tecnologia.Id,
          Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? tecnologia.Valor : tecnologia.Valor_en,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idNivelAccesoTecnologia') {
            field.value =
              this.datosPersona[field.name as keyof typeof this.datosPersona];
            field.options = tiposNivelTecnologia;
          }
          return field;
        });
      });
  }

  abrirModal() {
    this.modalDatosAdicionales.nativeElement.click();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['datosPersona']) {
      this.datosPersona = changes['datosPersona']
        .currentValue as DatosAdicionalesPersonaDTO;
    }
  }

  onSubmitPersona(form: FormGroup) {
    const json: DatosAdicionalesPersonaDTO = {
      idPersona: this.dataUsuario.idPersona,
      codigoPostal: +form.get('codigoPostal')?.value,
      idEstratoSocioeconomico: +form.get('idEstratoSocioeconomico')?.value,
      idGrupoEtnico: +form.get('idGrupoEtnico')?.value,
      idNivelEducativo: +form.get('idNivelEducativo')?.value,
      idOcupacion: +form.get('idOcupacion')?.value,
      idPais: this.soloNumero(this.datosPersona.country),
      idDepartamento: this.soloNumero(this.datosPersona.departament),
      idMunicipio: this.soloNumero(this.datosPersona.municipality),
      direccion: form.get('direccion')?.value,
      idGenero: +form.get('idGenero')?.value,
      idTipoArea: +form.get('idTipoArea')?.value,
      idTiposDiscapacidad: form
        .get('idTiposDiscapacidad')
        ?.value.map((valor: string) => Number(valor)),
      idNivelAccesoTecnologia: form
        .get('idNivelAccesoTecnologia')
        ?.value.map((valor: string) => Number(valor)),
    };
    this.saveDatosPersona(json);
    this.submitAction.emit(form);
  }

  saveDatosPersona(json: DatosAdicionalesPersonaDTO) {
    this.datosProvisionalesService
      .guardarDatosProvisionalesPersona(json)
      .subscribe((response: any) => {
        if (response.success) {
          this.updateDetalle(json);
          this.alertService.exito(this.modalText['save-datos']);
          this.openModalAbogado = true;
          if (!this.openConfigCuenta) {
            if (this.primerInicioSesion) {
              setTimeout(() => {
                this.ModalDatosAdicionalesAbogadoComponent.abrirModal();
              }, 500);
            }
          }

        } else {
          this.alertService.error(response.message);
        }
      });
  }

  updateDetalle(data: DatosAdicionalesPersonaDTO) {
    const datosSesion: UserDataDto = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    datosSesion.pais = data.idPais;
    datosSesion.departamento = data.idDepartamento;
    datosSesion.municipio = data.idMunicipio;

    sessionStorage.setItem(
      Constants.USER_INFORMATION_STORAGE,
      JSON.stringify(datosSesion)
    );
  }

  getDatosAdicionalesPersona(idPersona: number) {
    setTimeout(() => {
      this.datosProvisionalesService
        .getDataPersona(idPersona)
        .subscribe((response: GetDatoAdicionalesPersonaDTO) => {
          this.datosPersona = {
            direccion: response.direccionPersona?.Direccion_Notificacion,
            idTipoArea: response.direccionPersona?.Tipo_Area,
            codigoPostal: response.datoAdicionalPersona?.Codigo_Postal,
            fechaNacimiento: response.datoAdicionalPersona?.Fecha_Nacimiento
              ? this.formatearFecha(response.datoAdicionalPersona.Fecha_Nacimiento)
              : response.personaNatural?.Fecha_Nacimiento ?
                this.formatearFecha(response.personaNatural.Fecha_Nacimiento)
                : '',
            idGenero: response.personaNatural?.Id_Sexo,
            idEstratoSocioeconomico:
              response.datoAdicionalPersona?.Id_Estrato_Socioeconomico,
            idGrupoEtnico: response.datoAdicionalPersona?.Id_Grupo_Etnico,
            idNivelEducativo: response.datoAdicionalPersona?.Id_Nivel_Educativo,
            idOcupacion: response.datoAdicionalPersona?.Id_Ocupacion,
            idTiposDiscapacidad: response.tipoDiscapacidadPersona
              ?.map(id => id.Id_Discapacidad)
              .filter((id): id is number => id !== undefined),
            idNivelAccesoTecnologia: response.nivelTecnologiaPersona
              ?.map(id => id.Id_Tipo_Tecnologia)
              .filter((id): id is number => id !== undefined),
            country: response.idPais,
            departament: response.idDepartamento,
            municipality: response.idMunicipio,
            email: this.dataUsuario.correoElectronico,
            emailConfirm: this.dataUsuario.correoElectronico,
          };

          this.allFields = this.allFields.map(field => {
            if (
              this.datosPersona[
              field.name as keyof typeof this.datosPersona
              ] !== undefined
            ) {
              field.value =
                this.datosPersona[field.name as keyof typeof this.datosPersona];
            }
            return field;
          });
        });
    }, 500);
  }

  formatearFecha(fecha: string): string | undefined {
    if (!fecha) return;

    // Separar la fecha manualmente para evitar problemas de interpretación
    const [year, month, dayTime] = fecha.split('-');
    if (!year || !month || !dayTime) return;

    const day = dayTime.split('T')[0];

    return `${year}-${month}-${day}`; // Formato YYYY-MM-DD
  }

  showGuia() {
    if (this.ruta.split('/')[1].includes('expediente')) {
      this.datosProvisionalesService.activarGuia(true);
    } else {
      this.datosProvisionalesService.activarGuia(false);
    }
  }
  soloNumero(value: number | number[] | undefined): number | undefined {
    if (Array.isArray(value)) return value[0];
    return value;
  }

  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }
}
